import { authApiCall } from "./gateway-client";
import { ROUTES } from "@/lib/constants";
import type { StaffProfile } from "@/types/auth";

export async function getProfile() {
  return authApiCall<StaffProfile>({
    endpoint: "/auth/staff/profile",
    method: "GET",
  });
}

export async function exchangeCode(code: string) {
  const response = await fetch(ROUTES.AUTH.EXCHANGE_CODE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
    credentials: "include",
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(
      (error as { message?: string }).message || "Failed to exchange code",
    );
  }

  return response.json();
}

export async function logout() {
  try {
    await fetch(ROUTES.AUTH.LOGOUT, {
      method: "POST",
      credentials: "include",
    });
  } catch (error) {
    console.error("Logout error:", error);
  }

  window.location.replace("/login");
}
